import React from 'react'
import moment from 'moment'
import { DateRangePicker } from 'components/DatePickerStyled/DateRangePicker'

const AppliedDateFilter = ({ filterValues, handleFilterChange }) => {
  const value = filterValues?.selectedAppliedDateRange || []

  // Don't allow selecting dates in the future — candidates can't apply later than now
  const disabledDate = current => current && current > moment().endOf('day')

  return (
    <div style={{ padding: '4px 0' }}>
      <label
        style={{
          display: 'block',
          marginBottom: '4px',
          fontWeight: 500,
          color: '#404040',
        }}
      >
        Applied Date &amp; Time
      </label>
      <DateRangePicker
        picker="date"
        showTime={{ format: 'hh:mm A' }}
        format="DD/MM/YYYY hh:mm A"
        width="100%"
        placeholder={['From date & time', 'To date & time']}
        value={value && value.length ? value : null}
        disabledDate={disabledDate}
        allowClear
        onChange={dates =>
          handleFilterChange(dates || [], 'selectedAppliedDateRange')
        }
      />
    </div>
  )
}

export default AppliedDateFilter
